import { Fields } from '@/lib/PlanFields'

export const FilterType = {
  Department: 'department',
  Role: 'role',
  Level: 'level',
  Location: 'officeLocation',
  Manager: 'manager',
  CustomField: 'customField',
  CustomFieldV2: 'customFieldv2',
  ScenarioStatus: 'scenarioStatus',
  WorkforceStatus: 'workforceStatus',
  SensitiveData: 'sensitiveData',
  PositionPlanning: 'positionPlanning',
  PositionPlanningScenarioPositions: 'positionPlanningScenarioPositions',
  SpanOfControl: 'spanOfControl',
  StartDateRange: 'startDateRange',
  EndDateRange: 'endDateRange'
}

export const calculatedFields = [
  FilterType.Level,
  FilterType.WorkforceStatus,
  FilterType.PositionPlanning,
  FilterType.PositionPlanningScenarioPositions,
  FilterType.ScenarioStatus,
  FilterType.SpanOfControl,
  FilterType.Manager,
  FilterType.ScenarioStatus
]

export const dateRangeFields = [FilterType.StartDateRange, FilterType.EndDateRange]
export const dateRangeConditionFields = {
  between: ['fromDate', 'toDate'],
  before: ['toDate'],
  after: ['fromDate'],
  on: ['fromDate'],
  blank: []
}
export const dateRangeConditions = Object.keys(dateRangeConditionFields)

export const isDateRangeCategory = (filter) => filter?.isDateRange === true

export const isDateRangeFilterComplete = (filter = {}) => {
  const condition = filter.condition || 'between'
  const requiredFields = dateRangeConditionFields[condition]

  return Boolean(requiredFields?.every((field) => filter[field]))
}

// Accepts a category object (custom date fields) or a filter type string.
export const getDateRangeCategoryLabel = (filterCategory) => {
  if (filterCategory?.name) return filterCategory.name
  const filterType = typeof filterCategory === 'string' ? filterCategory : filterCategory?.type
  if (filterType === FilterType.StartDateRange) return 'Start Date'
  if (filterType === FilterType.EndDateRange) return 'End Date'
  return null
}

const getDateRangeFilterName = (filterCategory, filter) => {
  const label = getDateRangeCategoryLabel(filterCategory)

  if (filter.condition === 'between') {
    return `${label}: ${filter.fromDate} to ${filter.toDate}`
  }
  if (filter.condition === 'before') return `${label}: before ${filter.toDate}`
  if (filter.condition === 'after') return `${label}: after ${filter.fromDate}`
  if (filter.condition === 'on') return `${label}: on ${filter.fromDate}`
  return `${label}: is blank`
}

export const buildDateRangeFilter = (filterCategory, filter) => {
  const filterData = {
    type: filterCategory.type,
    id: filterCategory.id,
    name: getDateRangeFilterName(filterCategory, filter),
    condition: filter.condition,
    isDateRange: true
  }
  // typeId is the backend's routing key for custom field filters
  if (filterCategory.typeId) filterData.typeId = filterCategory.typeId
  const requiredFields = dateRangeConditionFields[filter.condition]

  for (let i = 0; i < requiredFields.length; i++) {
    const field = requiredFields[i]
    filterData[field] = filter[field]
  }

  return filterData
}

// Matching typeId besides id sweeps out legacy exact-value options saved
// before the field became a Date type (same typeId, value-based ids).
const matchesDateRangeField = (filter, fieldId) =>
  filter.id === fieldId || filter.typeId === fieldId

export const upsertDateRangeFilter = (filterData, filters = []) => {
  const fieldId = filterData.typeId || filterData.id
  const nextFilters = filters.filter(
    (filter) => filter.type !== '' && !matchesDateRangeField(filter, fieldId)
  )
  nextFilters.push(filterData)
  return nextFilters
}

export const clearDateRangeFilter = (filterId, filters = []) =>
  filters.filter((filter) => !matchesDateRangeField(filter, filterId))

export const getDisplayFieldForDateRange = (filterType) => {
  if (filterType === FilterType.StartDateRange) return Fields.startDate
  if (filterType === FilterType.EndDateRange) return Fields.endDate
  return null
}
